import {
    Stack,
    Typography,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    FormControl,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';  
import dayjs from "dayjs";
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import DatesPicker from 'src/components/mui/datespicker';
import Page from '../../components/Page';
import Editor from '../../components/editor';

const Popup = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [popup, setPopup] = useState('')
    const [loading, setLoading] = useState(false)
    const [content, setContent] = useState('')
    const [daterange, setDateRange] = useState({
        startname: '시작일시',
        startdate: new Date(),
        endname: '종료일시',
        enddate: new Date()
    });
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/popups/${params.id}`)
            const payload = response.data;
            setPopup(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            title: popup?.title,
            resume: popup?.resume
        }
        reset(defaultValues)

        setDateRange({
            ...daterange,
            startdate: new Date(popup.fromdate),
            enddate: new Date(popup.todate)
        })

        // callback editor
        setContent(popup?.descript)

    }, [reset, popup]);

    const goBack = () => {
        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        setLoading(true)

        const params = {
            "title": data.title,
            "descript": content,
            "resume": data.resume,
            "fromdate": dayjs(daterange.startdate).format("YYYY-MM-DD"),
            "todate": dayjs(daterange.enddate).format("YYYY-MM-DD")
        };

        await apiService.put(`/popups/${popup.id}`, params)
        .then(response => {
            toast.success('업데이트 되었습니다.')
            goBack()
        }).catch(error => {
            console.error(error)
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <Page title="Popup">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="popupform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                팝업
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='제목'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction="row" spacing={3} >
                                    <FormControl>
                                        <Controller
                                            name='resume'
                                            control={control}
                                            rules={{ required: true }}
                                            defaultValue="7"
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    type='number'
                                                    value={value}
                                                    label='재개날짜'
                                                    id='resume'
                                                    onChange={onChange}
                                                    placeholder='고객이 다시 보지 않음을 선택할 시 몇 일후 팝업레이어를 보여주는 것을 설정합니다.'
                                                    error={Boolean(errors.resume)}
                                                    aria-describedby='validation-async-resume'
                                                />
                                            )}
                                        />
                                        {errors.resume && (
                                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-resume'>
                                                필수
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                    <DatesPicker daterange={daterange} setDateRange={setDateRange} />
                                </Stack>
                            </Grid>

                            <Grid item xs={12}>
                                <Editor content={content} setContent={setContent} />
                            </Grid>

                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="popupform" variant='contained'>
                        {loading ? (
                            <CircularProgress
                                sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                }}
                            />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}>
                        취소
                    </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Popup